<template>
  <div class="confirm">
    <v-dialog
      v-model="dialog"
      max-width="400"
    >
      <v-card flat>
        <v-card-title>確認</v-card-title>
        <v-card-text style="white-space: pre-line;">
          {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="cancel"
          >
            キャンセル
          </v-btn>
          <v-btn
            :color="acceptColor"
            depressed
            @click="accept"
          >
            {{ acceptText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'Confirm',
  data: () => ({
    dialog: false,
    resolve: null,
    message: null,
    acceptText: null,
    acceptColor: null
  }),
  watch: {
    dialog(val) {
      if (!val) {
        this.resolve(false);
      }
    }
  },
  methods: {
    open(message, acceptText = 'OK', acceptColor = 'primary') {
      return new Promise(resolve => {
        this.message = message;
        this.acceptText = acceptText;
        this.acceptColor = acceptColor;
        this.resolve = resolve;
        this.dialog = true;
      });
    },
    accept() {
      this.dialog = false;
      this.resolve(true);
    },
    cancel() {
      this.dialog = false;
      this.resolve(false);
    }
  }
};
</script>
